import ScrollHint from 'scroll-hint'
import 'scroll-hint/css/scroll-hint.css';

class ScrollerHint {
  constructor(el) {
    this.dom = {el: el};

    this.init();
  }

  init() {
    // new ScrollHint(this.dom.el, {
    new ScrollHint('.js-scrollable', {
      suggestiveShadow: false,
      i18n: {
        scrollable: 'スクロールできます'
      }
    });
  }
}

export default ScrollerHint